export const theme = {
	none: 'transparent',

	background: '#0A0A0B',

	border: 'rgba(255, 255, 255, 0.1)',

	FONTS_PRIMARY: "'Google Sans', sans-serif",

	text_title_main: '#ffffff',
	text_title_alt: 'rgba(255, 255, 255, 0.65)',
	text_desc_main: '#fafafa',
	text_desc_alt: 'rgba(255, 255, 255, 0.65)',

	text_red: 'rgb(153, 27, 27)',
	text_green: '#47c06e',
	text_theme: 'rgb(13, 148, 136)',
	text_orange: 'rgb(255, 183, 3)',

	toast_bg: 'rgba(22, 22, 22, 1)',
	toast_fg: '#ffffff',

	nav_bg: 'rgba(7, 9, 14, 1)',
	nav_fg: '#ffffff',
	nav_alt_fg: 'rgba(255, 255, 255, 0.5)',

	nav_bg_new: 'rgb(25, 33, 54)',

	panel_main_bg: '#0c1014',
	panel_main_border: 'rgba(255, 255, 255, 0.075)',

	panel_highlight_bg: '#0d1115',
	panel_highlight_border: 'rgba(255, 255, 255, 0.1)',

	table_row_sub_divider: 'rgba(255, 255, 255, 0.4)',

	table_row_bg: 'rgba(255, 255, 255, 0.1)',
	table_row_bg_hover: 'rgba(255, 255, 255, 0.025)',

	table_row_border: 'rgba(255, 255, 255, 0.075)',
	table_row_red_bg: 'rgba(204, 99, 99, 0.2)',
	table_row_yellow_bg: 'rgba(255, 200, 0, 0.15)',
	table_row_blue_bg: 'rgba(162, 234, 255, 0.1)',
	table_row_green_bg: 'rgba(120, 200, 120, 0.15)',

	table_head_bg: 'rgba(255, 255, 255, 0.05)',
	table_head_border: 'rgba(255, 255, 255, 0.075)',

	modal_bg: 'rgba(22, 22, 22, 1)',
	modal_backdrop: 'rgba(0, 0, 0, 0.5)',

	// NOTE: Input
	input_bg: 'rgba(255, 255, 255, 0.05)',
	input_fg: '#fafafa',
	input_placeholder: 'rgba(255, 255, 255, 0.3)',
	input_border: 'rgba(255, 255, 255, 0.1)',
	input_border_active: '#0d9488',

	file_fg: '#fafafa',
	file_alt_fg: 'rgba(255, 255, 255, 0.4)',
	file_bg: 'rgba(255, 255, 255, 0.05)',
	file_border: 'rgba(255, 255, 255, 0.1)',
	file_border_active: '#0d9488',

	checkbox_bg: 'rgba(255, 255, 255, 0.1)',
	checkbox_border: 'rgba(255, 255, 255, 0.1)',
	checkbox_fg: '#0d9488',

	select_bg: 'rgba(255, 255, 255, 0.1)',
	select_fg: '#fafafa',
	select_border: 'rgba(255, 255, 255, 0.1)',
	select_dropdown_bg: 'rgba(22, 22, 22, 1)',
	select_dropdown_bg_hover: 'rgba(255, 255, 255, 0.05)',
	select_dropdown_bg_selected: 'rgba(255, 255, 255, 0.1)',

	select_dropdown_fg: '',
	select_dropdown_border: 'rgba(255, 255, 255, 0.1)',

	// Note: Bubbles
	bubble_grey_bg: 'rgba(255, 255, 255, 0.1)',
	bubble_grey_fg: '#fafafa',
	bubble_grey_border: 'rgba(255, 255, 255, 0.1)',

	bubble_white_bg: '#fafafa',
	bubble_white_fg: 'rgb(22, 22, 22)',
	bubble_white_border: 'rgba(255, 255, 255, 0.85)',

	bubble_red_bg: '',
	bubble_red_fg: '',
	bubble_red_border: '',

	// NOTE: Button
	button_grey_bg: 'rgba(255, 255, 255, 0.1)',
	button_grey_bg_hover: 'rgba(255, 255, 255, 0.2)',
	button_grey_fg: '#fafafa',
	button_grey_border: 'rgba(255, 255, 255, 0.1)',
	button_grey_border_hover: '#0d9488',

	button_white_bg: 'rgba(255, 255, 255, 0.6)',
	button_white_bg_hover: 'rgba(255, 255, 255, 0.9)',
	button_white_fg: 'rgb(22, 22, 22)',
	button_white_border: 'rgba(255, 255, 255, 0.6)',
	button_white_border_hover: 'rgba(255, 255, 255, 1)',

	button_red_bg: 'rgba(255, 80, 80, 0.08)',
	button_red_bg_hover: 'rgba(255, 80, 80, 0.18)',
	button_red_fg: '#fca5a5',
	button_red_border: '#b91c1c',
	button_red_border_hover: '#ef4444',

	button_purple_bg: 'rgba(194, 122, 255, 0.08)',
	button_purple_bg_hover: 'rgba(194, 122, 255, 0.33)',
	button_purple_fg: 'rgb(218, 175, 255)',
	button_purple_border: 'rgb(194, 122, 255)',
	button_purple_border_hover: 'rgb(206, 149, 255)',

	button_orange_bg: 'rgba(249, 115, 22, 0.08)',
	button_orange_bg_hover: 'rgb(234, 88, 12, 0.33)',
	button_orange_fg: 'rgb(251, 171, 115)',
	button_orange_border: 'rgb(249, 115, 22)',
	button_orange_border_hover: 'rgb(250, 143, 69)',

	button_green_bg: 'rgba(34, 197, 94, 0.08)',
	button_green_bg_hover: 'rgba(34, 197, 94, 0.33)',
	button_green_fg: '#86efac',
	button_green_border: '#15803d',
	button_green_border_hover: '#22c55e',

	button_yellow_bg: 'rgba(255, 180, 0, 0.08)',
	button_yellow_bg_hover: 'rgba(255, 180, 0, 0.18)',
	button_yellow_fg: '#ffd166',
	button_yellow_border: '#cc9200',
	button_yellow_border_hover: '#ffb703',

	// NOTE: New Buttons
	button_dark_highlight_bg: 'rgba(255, 255, 255, 0)',
	button_dark_highlight_bg_hover: 'rgba(255, 255, 255, 0.075)',
	button_dark_highlight_fg: '#a1a1a4',
	button_dark_highlight_fg_hover: '#ffffff',
	button_dark_highlight_border: 'rgba(255, 255, 255, 0.1)',
	button_dark_highlight_border_hover: 'rgba(255, 255, 255, 0.2)',

	button_dark_bg: 'rgba(255, 255, 255, 0)',
	button_dark_bg_hover: 'rgba(255, 255, 255, 0.075)',
	button_dark_fg: '#ffffff',
	button_dark_border: 'rgba(255, 255, 255, 0.1)',
	button_dark_border_hover: 'rgba(255, 255, 255, 0.2)',
};
